import { ref, reactive } from 'vue';
import moment from 'moment';

const initialState = () => {
    return {
        menus: reactive([]),
    };
};

const state = initialState();

const mutations = {
    setMenuState(state, value) {
        state.menus = value;
    },
};

const getters = {
    menus(state) {
        return state.menus;
    },
};

export default {
    state,
    // actions,
    mutations,
    getters,
};
